import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NullAndEmptyAnchorsService {
  handlingAnchors(content: PageContentDto) {
    if (content.Anchor === null || content.Anchor === '') {
      return 'DTX_' + content.Id;
    } else {
      return content.Anchor;
    }
  }
}
